import React from 'react'
import {Box, MenuItem} from '@mui/material'
import LoadingSpinner from '../../../genericComponents/LoadingSpinner'
import {NoData} from '../../../genericComponents/NoData'
import NotificationItem from './NotificationItem/NotificationItem'
import {NotificationDTO} from '../../../generated/api'


const NotificationsPanel = ({notifications, isLoading} : {notifications: NotificationDTO[], isLoading: boolean}) => {

    return (
        <Box p={1} className="datx-notification-panel">
            {isLoading ? (
                <LoadingSpinner />
            ) : notifications?.length ? (
                notifications.map((notification:NotificationDTO) => (
                    <MenuItem
                        className="notification-panel-single-item"
                        key={notification.id}
                    >
                        {NotificationItem(notification)}
                    </MenuItem>
                ))
            ) : (
                <NoData message="No notifications available!" />
            )}
        </Box>
    )
}

export default NotificationsPanel
